import { Dialogs } from '@leverege/ui-elements';
import { AllowedReducer, Constants } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
// import { Context } from '@leverege/plugin'
import RejectTransferView from "./RejectTransferView.js";
const ACTION = 'rejectTransfer';
export default {
  id: 'actions.rejectTransfer',
  name: 'Reject Transfer',
  layout: {
    sort: 'z'
  },
  matches: [{
    use: ['contextMenu'],
    path: ['parentTransfer']
  }],
  isPrepared: context => {
    const {
      target: targets
    } = context;
    if (targets.length === 0) return true;
    const target = targets[0];
    const transferId = target.id;
    const a = AllowedReducer.get(GlobalState.get(), transferId);
    return a[ACTION] != null;
  },
  prepare: async context => {
    const {
      target: targets
    } = context;

    // get resource id
    const target = targets[0];
    const transferId = target.id;
    const transfer = GlobalState.get()?.models?.lookup?.[transferId];
    const systemId = transfer.systemId;
    return GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      const res = await api.system(systemId).device(transferId).srv('ownershipTransfer').post('rejectBulkTransfer', null, {
        test: true
      });
      dispatch({
        type: Constants.ALLOWED_SET,
        resourceId: transferId,
        action: ACTION,
        allowed: res.allowed === true
      });
      return res.allowed === true;
    });
  },
  handles: context => {
    const {
      target: targets
    } = context;
    if (targets.length !== 1) {
      return false;
    }
    const transfer = GlobalState.get()?.models?.lookup?.[targets[0].id];

    // only handle incoming pending transfers
    if (transfer.data?.status !== 'pending' || transfer.data?.type !== 'incoming') {
      return false;
    }
    const transferId = targets[0]?.id;
    const a = AllowedReducer.get(GlobalState.get(), transferId);
    return a[ACTION] === true;
  },
  appearance: ({
    context,
    action
  }) => {
    return {
      name: 'Reject Transfer',
      icon: 'fa fa-xmark'
    };
  },
  perform: ({
    context
  }) => {
    const {
      target: targets,
      reloadData
    } = context;
    const parentIncomingTransfer = GlobalState.get()?.models?.lookup?.[targets[0].id];
    Dialogs.show({
      component: RejectTransferView,
      props: {
        parentIncomingTransfer,
        reloadData
      }
    });
  }
};